export default __webpack_public_path__ + "locales/sr-Cyrl-RS/EmptyView.json?hash=c4c9b653b9f0fd10d5cd7ca53eafd064";